'use client'
import { ModalCloseButton as ChakraModalCloseButton } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { ModalCloseButtonProps } from './ModalCloseButton.types'

export default forwardRef(function ModalCloseButton(
  _props: ModalCloseButtonProps,
  ref: LegacyRef<HTMLButtonElement>
) {
  return <ChakraModalCloseButton ref={ref} translate="no" />
})
